import { createFileRoute } from '@tanstack/react-router'
import React from "react";
import Master_UsersView from "../../../master/UsersView.tsx";

export const Route = createFileRoute('/_app/master/users/$user_uid')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Master_UsersView />
}
